import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-data-filter-message',
  templateUrl: './data-filter-message.component.html',
  styleUrls: ['./data-filter-message.component.scss']
})
export class DataFilterMessageComponent {

  @Input() icon: string;
  @Input() labelKey: string;

}
